import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { LoadingController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

const HTML_TEMPLATE = `
<ion-grid class="grid">
  <ion-row>
    <ion-col (click)="callGallery()">
      <div class="icon-container">
        <thf-icon name="upload" class="icon"></thf-icon>
      </div>
      <div class="label-container">        
        <p >{{'COMMON.INPUTIMAGE.GALLERY' | translate}}</p>
      </div>
	</ion-col>
    <ion-col (click)="callCamera()" >
      <div class="icon-container">
        <thf-icon name="camera" class="icon"></thf-icon>
      </div>
      <div class="label-container">
          <p >{{'COMMON.INPUTIMAGE.CAMERA' | translate}}</p>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
`;

const CSS_STYLE = `    
.grid {
	padding: 0px;
	ion-col {
	  border-bottom: 1px solid #eceeee;
	  border-left: 1px solid #eceeee;
	  border-top: 1px solid #eceeee;
	  text-align: center;
	}

	ion-col div {
		font-size: 20px;
	}

	p {       
		font-family: NunitoSans;
		font-size: 15px;
		font-weight: bold;
		font-style: normal;
		padding: 3px 0 12px 0px !important;
		margin: 0;
		font-stretch: normal;
		line-height: 1.5;
		letter-spacing: normal;
		color: #0c9abe;
	  }
  }

  .icon-container {
	padding-top: 10px;
  }

  .label-container {
	  margin-top: -4px !important;
  }

  .icon {
	color:#0c9abe;
	font-size: 24px;
	font-weight: bold;
	margin-left: 12px;
}
`;

/*@Component({
	selector: 'input-image',
	template: HTML_TEMPLATE,
	styles: [CSS_STYLE],
	encapsulation: ViewEncapsulation.None

})*/

export class InputImageComponent {

	@Input('callback') callback: Function;

	text: string;
	loader: any;

	constructor(private _camera: Camera,
		private _loadingCtrl: LoadingController,
		private _i18n: TranslateService) {
	}

	async callGallery() {
		this.loader = this._loadingCtrl.create({
			content: this._i18n.instant("COMMON.AGUARDE") + "..."
		});

		await this.loader.present();

		const options: CameraOptions = {
			quality: 100,
			destinationType: this._camera.DestinationType.FILE_URI,
			sourceType: this._camera.PictureSourceType.PHOTOLIBRARY,
			saveToPhotoAlbum: false,
			correctOrientation: true,
		}

		this.selectPhoto(options);
	}

	async callCamera() {
		this.loader = this._loadingCtrl.create({
			content: this._i18n.instant("COMMON.AGUARDE") + "..."
		});

		await this.loader.present();

		const options: CameraOptions = {
			quality: 50,
			destinationType: this._camera.DestinationType.FILE_URI,
			encodingType: this._camera.EncodingType.JPEG,
			mediaType: this._camera.MediaType.PICTURE,
			correctOrientation: true
		}

		this.selectPhoto(options);
	}

	selectPhoto(options) {

		this._camera.getPicture(options).then((imageData) => {
			this.callback(imageData);
			this.loader.dismiss();
		}).catch(err => { console.log(err); this.loader.dismiss(); });
	}
}
